import { modelRequest } from '@stem-sims/nexus'
import { SignUpProps } from '../types/accountTypes'

export function post(props: SignUpProps) {
    return modelRequest.post("/api/sign-up", props)
}

